"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.f104 = void 0;
exports.f104 = {
    "ha": [
        "Latn",
        "Arab",
        "Brai"
    ],
    "haa": [
        "Latn"
    ],
    "hab": [
        "Zxxx"
    ],
    "hac": [
        "Arab"
    ],
    "had": [
        "Latn"
    ],
    "hae": [
        "Latn"
    ],
    "haf": [
        "Zxxx"
    ],
    "hag": [
        "Latn"
    ],
    "hah": [
        "Latn"
    ],
    "hai": [
        "Latn"
    ],
    "haj": [
        "Latn",
        "Beng"
    ],
    "hak": [
        "Hans",
        "Hant",
        "Latn"
    ],
    "hal": [
        "Latn"
    ],
    "ham": [
        "Latn"
    ],
    "han": [
        "Latn"
    ],
    "hao": [
        "Latn"
    ],
    "hap": [
        "Latn"
    ],
    "haq": [
        "Latn"
    ],
    "har": [
        "Ethi",
        "Arab",
        "Latn"
    ],
    "has": [
        "Latn"
    ],
    "hav": [
        "Latn"
    ],
    "haw": [
        "Latn"
    ],
    "hax": [
        "Latn"
    ],
    "hay": [
        "Latn"
    ],
    "haz": [
        "Arab"
    ],
    "hba": [
        "Latn"
    ],
    "hbb": [
        "Latn"
    ],
    "hbn": [
        "Latn"
    ],
    "hbo": [
        "Hebr"
    ],
    "hbu": [
        "Latn"
    ],
    "hca": [
        "Zyyy"
    ],
    "hch": [
        "Latn"
    ],
    "hds": [
        "Zxxx"
    ],
    "hdy": [
        "Ethi",
        "Latn"
    ],
    "he": [
        "Hebr",
        "Brai"
    ],
    "hed": [
        "Latn"
    ],
    "heg": [
        "Latn"
    ],
    "heh": [
        "Latn"
    ],
    "hei": [
        "Latn"
    ],
    "hem": [
        "Latn"
    ],
    "hgm": [
        "Latn"
    ],
    "hgw": [
        "Latn"
    ],
    "hhi": [
        "Latn"
    ],
    "hhr": [
        "Latn"
    ],
    "hhy": [
        "Latn"
    ],
    "hi": [
        "Deva",
        "Brai",
        "Mahj",
        "Newa"
    ],
    "hia": [
        "Latn"
    ],
    "hib": [
        "Latn"
    ],
    "hid": [
        "Latn"
    ],
    "hif": [
        "Latn",
        "Deva"
    ],
    "hig": [
        "Latn"
    ],
    "hih": [
        "Latn"
    ],
    "hii": [
        "Takr",
        "Deva"
    ],
    "hij": [
        "Latn"
    ],
    "hik": [
        "Latn"
    ],
    "hil": [
        "Latn",
        "Brai"
    ],
    "hio": [
        "Latn"
    ],
    "hir": [
        "Latn"
    ],
    "hit": [
        "Xsux"
    ],
    "hiw": [
        "Latn"
    ],
    "hix": [
        "Latn"
    ],
    "hji": [
        "Latn"
    ],
    "hka": [
        "Latn"
    ],
    "hke": [
        "Latn"
    ],
    "hkh": [
        "Arab",
        "Deva",
        "Latn"
    ],
    "hkk": [
        "Latn"
    ],
    "hkn": [
        "Zyyy"
    ],
    "hks": [
        "Zxxx"
    ],
    "hla": [
        "Latn"
    ],
    "hlb": [
        "Deva"
    ],
    "hld": [
        "Latn"
    ],
    "hle": [
        "Zyyy"
    ],
    "hlt": [
        "Latn"
    ],
    "hlu": [
        "Hluw"
    ],
    "hma": [
        "Zyyy"
    ],
    "hmb": [
        "Latn"
    ],
    "hmc": [
        "Zyyy"
    ],
    "hmd": [
        "Plrd",
        "Hmng",
        "Latn"
    ],
    "hme": [
        "Zyyy"
    ],
    "hmf": [
        "Latn"
    ],
    "hmg": [
        "Zyyy"
    ],
    "hmh": [
        "Zyyy"
    ],
    "hmi": [
        "Zyyy"
    ],
    "hmj": [
        "Bopo"
    ],
    "hmk": [
        "Zyyy"
    ],
    "hml": [
        "Zyyy"
    ],
    "hmm": [
        "Zyyy"
    ],
    "hmn": [
        "Latn",
        "Bopo",
        "Hmng"
    ],
    "hmp": [
        "Zyyy"
    ],
    "hmq": [
        "Bopo"
    ],
    "hmr": [
        "Latn"
    ],
    "hms": [
        "Latn"
    ],
    "hmt": [
        "Latn"
    ],
    "hmu": [
        "Latn"
    ],
    "hmv": [
        "Latn"
    ],
    "hmw": [
        "Zyyy"
    ],
    "hmy": [
        "Zyyy"
    ],
    "hmz": [
        "Latn",
        "Plrd"
    ],
    "hna": [
        "Latn"
    ],
    "hnd": [
        "Arab"
    ],
    "hne": [
        "Deva"
    ],
    "hng": [
        "Latn"
    ],
    "hnh": [
        "Latn"
    ],
    "hni": [
        "Latn"
    ],
    "hnj": [
        "Hmng",
        "Laoo",
        "Latn",
        "Plrd",
        "Thai"
    ],
    "hnn": [
        "Latn",
        "Hano"
    ],
    "hno": [
        "Arab"
    ],
    "hns": [
        "Latn"
    ],
    "hnu": [
        "Zyyy"
    ],
    "ho": [
        "Latn",
        "Brai"
    ],
    "hoa": [
        "Latn"
    ],
    "hob": [
        "Latn"
    ],
    "hoc": [
        "Deva",
        "Latn",
        "Orya",
        "Telu",
        "Wara"
    ],
    "hod": [
        "Latn"
    ],
    "hoe": [
        "Latn"
    ],
    "hoh": [
        "Zyyy"
    ],
    "hoi": [
        "Latn"
    ],
    "hoj": [
        "Deva"
    ],
    "hol": [
        "Latn"
    ],
    "hom": [
        "Latn"
    ],
    "hoo": [
        "Latn"
    ],
    "hop": [
        "Latn"
    ],
    "hor": [
        "Latn"
    ],
    "hos": [
        "Zxxx"
    ],
    "hot": [
        "Latn"
    ],
    "hov": [
        "Latn"
    ],
    "how": [
        "Hani"
    ],
    "hoy": [
        "Deva"
    ],
    "hoz": [
        "Zyyy"
    ],
    "hpo": [
        "Zyyy"
    ],
    "hps": [
        "Zxxx"
    ],
    "hr": [
        "Latn",
        "Brai"
    ],
    "hra": [
        "Latn"
    ],
    "hrc": [
        "Latn"
    ],
    "hre": [
        "Latn"
    ],
    "hrk": [
        "Latn"
    ],
    "hrm": [
        "Zyyy"
    ],
    "hro": [
        "Latn"
    ],
    "hrp": [
        "Latn"
    ],
    "hrt": [
        "Syrc"
    ],
    "hru": [
        "Latn"
    ],
    "hrw": [
        "Latn"
    ],
    "hrx": [
        "Latn"
    ],
    "hrz": [
        "Arab"
    ],
    "hsb": [
        "Latn"
    ],
    "hsh": [
        "Zxxx"
    ],
    "hsl": [
        "Zxxx"
    ],
    "hsn": [
        "Hans",
        "Hant"
    ],
    "hss": [
        "Zyyy"
    ],
    "ht": [
        "Latn"
    ],
    "hti": [
        "Latn"
    ],
    "hto": [
        "Latn"
    ],
    "hts": [
        "Latn"
    ],
    "htu": [
        "Latn"
    ],
    "htx": [
        "Xsux"
    ],
    "hu": [
        "Latn",
        "Brai"
    ],
    "hub": [
        "Latn"
    ],
    "huc": [
        "Latn"
    ],
    "hud": [
        "Latn"
    ],
    "hue": [
        "Latn"
    ],
    "huf": [
        "Latn"
    ],
    "hug": [
        "Latn"
    ],
    "huh": [
        "Latn"
    ],
    "hui": [
        "Latn"
    ],
    "huj": [
        "Zyyy"
    ],
    "huk": [
        "Latn"
    ],
    "hul": [
        "Latn"
    ],
    "hum": [
        "Latn"
    ],
    "huo": [
        "Zyyy"
    ],
    "hup": [
        "Latn"
    ],
    "huq": [
        "Zyyy"
    ],
    "hur": [
        "Latn"
    ],
    "hus": [
        "Latn"
    ],
    "hut": [
        "Tibt"
    ],
    "huu": [
        "Latn"
    ],
    "huv": [
        "Latn"
    ],
    "huw": [
        "Latn"
    ],
    "hux": [
        "Latn"
    ],
    "huy": [
        "Hebr"
    ],
    "huz": [
        "Cyrl"
    ],
    "hvc": [
        "Latn"
    ],
    "hve": [
        "Latn"
    ],
    "hvk": [
        "Latn"
    ],
    "hvn": [
        "Latn"
    ],
    "hvv": [
        "Latn"
    ],
    "hwa": [
        "Latn"
    ],
    "hwc": [
        "Latn"
    ],
    "hwo": [
        "Latn"
    ],
    "hy": [
        "Armn",
        "Brai"
    ],
    "hya": [
        "Latn"
    ],
    "hyw": [
        "Armn"
    ],
    "hz": [
        "Latn"
    ]
};
